import React, { useState, useEffect } from "react";
import StatusView from "../home//studentTabViews/TeacherStatus";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentStudyGroup } from "../../features/home/homeSlice";
import { HiPlusCircle } from 'react-icons/hi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSchool, faSchoolFlag, faPencil, faEdit } from "@fortawesome/free-solid-svg-icons";
import { SiGoogleclassroom } from 'react-icons/si';
import { _ } from 'lodash';
import  ACTIONS  from "../../redux/saga_actions";
import StudyClassForm from "./StudyClassForm";
import config from "../../config";
import { getAuthHeader } from "../../services/auth_helper";
import { setPopup } from "../../features/globalReducer";
import { UPDATE_USER } from "../../features/user/user_slice";


const STUDYGROP_DEFAULT = {
    title: '',
    description: '',
    level: '',
    img_url: '',
    archive: false,
    tags : []
}


const SumariesView = () => {
    const { studyGroups } = useSelector(state => state.homeReducer);
    const { user } = useSelector(state => state.userReducer);
    const [selectedStudyGroup, setSelectedStudyGroup] = useState(null);
    const currentStudyGroup = useSelector(state => state.homeReducer.currentStudyGroup);
    const [openModal, setOpenModal] = useState(undefined);
    const [branchOptions, setBranchOptions] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [branchSwitching, setBranchSwitching] = useState(false);
    const [branchError, setBranchError] = useState("");
    const canSwitchBranch = user?.role === 'admin';
    const dispatch = useDispatch();
    function handleSelectGroup(index) {
        setSelectedStudyGroup(studyGroups[index]);
        setCurrentStudyGroup(studyGroups[index]);
        // set current study group to studyGroups[index] 
        // dispatch home/setCurrentStudyGroup  to studyGroups[index]
        dispatch({ type: 'home/setCurrentStudyGroup', payload: studyGroups[index] });
        dispatch({ type: 'FETCH_STUDENTS_BY_STUDYGROUP', payload: studyGroups[index]._id })
        setOpenModal(undefined)
    }
    
    const onInitCreateStudyGroup = () => {
        console.log("onInitCreateStudyGroup");
        dispatch({ type: ACTIONS.UPDTAE_CURRENTSTUDYGROUP, payload: {...STUDYGROP_DEFAULT} });
        setOpenModal('addNewGroup');
    }



    const onSetEditStudyGroup = (index) => {
        // dispatch({ type: ACTIONS.UPDTAE_CURRENTSTUDYGROUP, payload: studyGroup });
        if (index >= 0 && index < studyGroups.length) {
            dispatch({ type: ACTIONS.UPDTAE_CURRENTSTUDYGROUP, payload: studyGroups[index] });
            setOpenModal('addNewGroup');
        }
    }

    const onClickSelectClass = () => {
        setOpenModal('selectClass');
    }

    const onClickSelectBranch = () => {
        if (!canSwitchBranch) return;
        setOpenModal('selectBranch');
    }

    // on start if studyGroups is not empty and currentStudyGroup is null 
    // set currentStudyGroup to studyGroups last element
    useEffect(() => { 
        if(currentStudyGroup != null){
            // find currentStudyGroup in studyGroups
            const index = studyGroups.findIndex((studyGroup) => studyGroup._id == currentStudyGroup._id);
            if(!index >= 0){
                handleSelectGroup(index );
            }
        }
        else if (studyGroups.length > 0 ) {
            handleSelectGroup(studyGroups.length - 1);
        }
    }, [studyGroups]);

    useEffect(() => {
        if (openModal !== 'selectBranch') return;
        const controller = new AbortController();
        const loadBranches = async () => {
            setBranchLoading(true);
            setBranchError("");
            try {
                const headers = getAuthHeader();
                if (!headers) {
                    setBranchError("Please login again.");
                    return;
                }
                const schoolId = user?.school_id;
                const schoolName = user?.school;
                const query = schoolId
                    ? `school_id=${encodeURIComponent(schoolId)}`
                    : schoolName
                        ? `school_name=${encodeURIComponent(schoolName)}`
                        : "";
                if (!query) {
                    setBranchError("School information not available.");
                    return;
                }
                const response = await fetch(`${config.URI}/api/schools/branches?${query}`, { headers, signal: controller.signal });
                const data = await response.json();
                if (!response.ok) {
                    setBranchError(data?.message || "Failed to load branches.");
                    return;
                }
                const branches = Array.isArray(data?.branches) ? data.branches : [];
                setBranchOptions(branches);
            } catch (error) {
                if (error?.name !== 'AbortError') {
                    setBranchError("Failed to load branches.");
                }
            } finally {
                setBranchLoading(false);
            }
        };
        loadBranches();
        return () => controller.abort();
    }, [openModal, user?.school_id, user?.school]);

    const handleSelectBranch = async (branch) => {
        if (!branch || !branch.code) return;
        if (branch.code === user?.branch_code) {
            setOpenModal(undefined);
            return;
        }
        setBranchSwitching(true);
        setBranchError("");
        try {
            const headers = getAuthHeader();
            if (!headers) {
                setBranchError("Please login again.");
                return;
            }
            const response = await fetch(`${config.URI}/api/user/branch`, {
                method: 'PATCH',
                headers,
                body: JSON.stringify({
                    branch_code: branch.code,
                    school_id: user?.school_id,
                })
            });
            const data = await response.json();
            if (!response.ok) {
                setBranchError(data?.error || "Failed to switch branch.");
                return;
            }
            dispatch(UPDATE_USER({
                school: data.school || user?.school,
                school_id: data.school_id || user?.school_id,
                branch: data.branch || branch.name,
                branch_code: data.branch_code || branch.code,
            }));
            dispatch(setPopup({
                title: "Branch Updated",
                message: `Switched to ${branch.name} (${branch.code})`,
                color: "green"
            }));
            dispatch({ type: ACTIONS.FETCH_STUDYGROUPS });
            dispatch({ type: ACTIONS.FETCH_PHONICGROUP });
            dispatch({ type: ACTIONS.FETCH_ASSIGNMENTS });
            setOpenModal(undefined);
        } catch (error) {
            setBranchError("Failed to switch branch.");
        } finally {
            setBranchSwitching(false);
        }
    }

    return (
        <>
            <div className="flex justify-center align-middle items-center px-5 py-5  w-full">
                <ol className="flex items-center w-full ">
                    <li className="flex w-full items-center text-blue-600 dark:text-blue-500 after:content-[''] after:w-full after:h-1 after:border-b after:border-blue-100 after:border-4 after:inline-block dark:after:border-blue-800">
                        <span className="flex items-center justify-center w-auto h-10 bg-blue-100 rounded-full lg:h-12  dark:bg-blue-800 shrink-0 px-5">
                            <button
                                onClick={canSwitchBranch ? onClickSelectBranch : undefined}
                                data-dropdown-toggle="dropdownAvatarName"
                                className={`flex items-center text-sm font-medium text-gray-900 rounded-full md:mr-0 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white ${canSwitchBranch ? "cursor-pointer hover:text-blue-600 dark:hover:text-blue-500" : "cursor-default"}`}
                                type="button"
                            >

                                <FontAwesomeIcon icon={faSchool} className="w-5 h-5 mr-2" />
                                {user?.school && user?.school != "none" ? user.school : "littleskoolhouse"} 
                                { user?.branch &&
                                    <span>  { ` : ${user.branch_code}`} </span> 
                                }
                            </button>
                        </span>
                    </li>
                    {  false &&
                    <li className="flex w-full items-center text-blue-600 dark:text-blue-500 after:content-[''] after:w-full after:h-1 after:border-b after:border-blue-100 after:border-4 after:inline-block dark:after:border-blue-800">
                        <span className="flex items-center justify-center w-auto h-10 bg-blue-100 rounded-full lg:h-12  dark:bg-blue-800 shrink-0 px-5">
                            <button data-dropdown-toggle="dropdownAvatarName" className="flex items-center text-sm font-medium text-gray-900 rounded-full hover:text-blue-600 dark:hover:text-blue-500 md:mr-0  focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white" type="button">
                                <FontAwesomeIcon icon={faSchoolFlag} className="w-5 h-5 mr-2" />
                                teachers
                            </button>
                        </span>
                    </li>
}
                    <li onClick={onClickSelectClass}
                        className="flex w-full items-center text-blue-600 dark:text-blue-500 after:content-[''] after:w-full after:h-1 after:border-b after:border-blue-100 after:border-4 after:inline-block dark:after:border-blue-800">
                        <span className=" flex items-center justify-center w-auto h-10 bg-blue-100 rounded-full lg:h-12  dark:bg-blue-800 shrink-0 px-5">
                            <button id="dropdownAvatarNameButton" data-dropdown-toggle="dropdownAvatarName" className="flex items-center text-sm font-medium text-gray-900 rounded-full hover:text-blue-600 dark:hover:text-blue-500 md:mr-0  focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white" type="button">
                                <SiGoogleclassroom className="w-5 h-5 mr-2" />
                                {selectedStudyGroup ? selectedStudyGroup.title : "Select a class"}
                            </button>
                        </span>
                    </li>
                    <li className="flex items-center w-full">
                        <span className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full lg:h-12 lg:w-12 dark:bg-gray-700 shrink-0">
                            <svg className="w-4 h-4 text-gray-500 lg:w-5 lg:h-5 dark:text-gray-100" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                                <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM7 2h4v3H7V2Zm5.7 8.289-3.975 3.857a1 1 0 0 1-1.393 0L5.3 12.182a1.002 1.002 0 1 1 1.4-1.436l1.328 1.289 3.28-3.181a1 1 0 1 1 1.392 1.435Z" />
                            </svg>
                        </span>
                    </li>
                </ol>
            </div>
            {
                openModal === 'selectBranch' &&
                <div className="absolute top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 z-10">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-80">
                        <div className="p-4 border-b">
                            <h2 className="text-xl font-semibold text-gray-800">Switch Branch</h2>
                            <p className="text-sm text-gray-400">Choose a branch to continue</p>
                        </div>
                        {branchLoading && (
                            <div className="p-4 text-sm text-gray-400">Loading branches...</div>
                        )}
                        {branchError && (
                            <div className="p-4 text-sm text-red-500">{branchError}</div>
                        )}
                        {!branchLoading && !branchError && branchOptions.length === 0 && (
                            <div className="p-4 text-sm text-gray-400">No branches available.</div>
                        )}
                        {branchOptions.map((branch) => {
                            const isCurrent = branch.code === user?.branch_code;
                            return (
                                <div
                                    key={branch.code || branch.name}
                                    onClick={() => {
                                        if (isCurrent || branchSwitching) return;
                                        handleSelectBranch(branch);
                                    }}
                                    className={
                                        isCurrent
                                            ? "p-2 border-t text-blue-500 cursor-default"
                                            : "p-2 border-t hover:bg-gray-50 cursor-pointer"
                                    }
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <span className="text-sm font-medium">{branch.name}</span>
                                            <span className="ml-2 text-xs text-gray-400">({branch.code})</span>
                                        </div>
                                        {isCurrent && (
                                            <span className="text-xs text-blue-500">Current</span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        <div
                            onClick={() => setOpenModal(undefined)}
                            className="p-2 border-t text-gray-500 hover:bg-gray-100 cursor-pointer"
                        >
                            <div className="flex items-center justify-center text-sm font-medium">
                                {branchSwitching ? "Switching..." : "Cancel"}
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                openModal === 'selectClass' &&
                <div
                   
                    className="absolute top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 z-10">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-80">
                        <div className="p-4 border-b">
                            <h2 className="text-xl font-semibold text-gray-800">Select a class</h2>
                            <p className="text-sm text-gray-400">Select a class to view data</p>
                        </div>
                        {studyGroups.map((studyGroup, index) => (
                            <div
                   
                                className={
                                    (currentStudyGroup?.title == studyGroup.title) ?
                                        "p-2 border-t text-blue-500 cursor-default" :
                                        "p-2 border-t  "
                                }>
                                <div className="flex items-center justify-between ">

                                    <div className="flex items-center w-full justify-between">
                                        <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                            {/* <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                                            </svg> */}
                                            { studyGroup?.img_url &&
                                                <img className="h-full w-full text-gray-300" src={studyGroup?.img_url} />
                                            }
                                            {
                                                !studyGroup?.img_url &&
                                                <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24"/>
                                            }
                                        </span>
                                        <p 
                                                         onClick={(event) => {
                                                            event.preventDefault();
                                                            handleSelectGroup(index)
                                                        
                                                        }}
                                        className="ml-2 cursor-pointer hover:text-purple-800 text-sm font-medium">{studyGroup.title}
                                        </p>
                                        <span  onClick={()=> onSetEditStudyGroup(index)}
                                         className="ml-2 text-xs cursor-pointer  font-medium text-gray-400 hover:text-blue-500 ">
                                            <FontAwesomeIcon icon={faEdit} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div 
                            onClick={() => { 
                                onInitCreateStudyGroup();    

                            }}
                            className="p-2 border-t hover:bg-green-500 text-green-500 hover:text-slate-50 cursor-pointer">
                            <div className="flex items-center justify-center ">
                                <span className="inline-block h-6 w-6 rounded-full overflow-hidden">
                                    <HiPlusCircle className="h-full w-full" />
                                </span>
                                <p className="ml-2 text-sm font-bold "> Create New Class</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {openModal === 'addNewGroup' &&
               <StudyClassForm setOpenModal={setOpenModal} />
            }
        </>
    );
}

export default SumariesView;
